export default __webpack_public_path__ + "static/media/information--stairs--g2.17a18300.png";